module.exports = __webpack_public_path__ + "static/media/Rectangle 5.a277aa2b.png";